export type ShotOrigin = (typeof ShotOrigin)[keyof typeof ShotOrigin];

export const ShotOrigin = {
  UNKNOWN: 'UNKNOWN',
  FIELD: 'FIELD',
  MID_RANGE: 'MID_RANGE',
  PAINT: 'PAINT',
} as const;

export function isShotOrigin(arg: unknown): arg is ShotOrigin {
  return Object.values(ShotOrigin).includes(arg as ShotOrigin);
}

export function isShotOriginArray(arg: unknown): arg is ShotOrigin[] {
  return Array.isArray(arg) && arg.every(isShotOrigin);
}
